import {has as _has} from 'lodash';
import PropTypes from 'prop-types';
import React from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router';
import {compose} from 'redux';
import {Segment} from 'semantic-ui-react';

import {gql, graphql, withApollo} from 'react-apollo';
import {routes} from '@constants/routes';
import {PUSH} from '@constants/variables';
import {sortByTextValue} from '@utils/sorters';
import {getLink} from '@appComponents/Link';
import {convertToInt} from '@utils/helpers';
import HeaderRenderer from '@appComponents/HeaderRenderer';
import * as thirdPartyStreamNamesPushGraphQl from '@graphql/clients/thirdPartyStreamNamesPush';
import {showModal} from '@utils/modal';
import {handleEditStreamNameModal} from '@modules/client/utils/clientTabsLayoutHelper';

import ProductThirdPartyStreamNamesIndexButtons from '../components/ProductThirdPartyStreamNamesIndexButtons';
import ProductThirdPartyStreamNamesPushTable from '../components/ProductThirdPartyStreamNamesPushTable';
import ProductThirdPartyStreamNamesPushForm from '../forms/ProductThirdPartyStreamNamesPushForm';
import {exportExcel} from '../utils/export/productThirdPartyStreamNamesIndexExcel';

export class ProductThirdPartyStreamNamesPushIndex extends React.Component {
    static propTypes = {
        cdns: PropTypes.array.isRequired,
        client: PropTypes.object.isRequired,
        DataProductThirdPartyStreamNamesPush: PropTypes.object.isRequired,
        match: PropTypes.object.isRequired,
        Modal: PropTypes.object,
        history: PropTypes.shape({
            push: PropTypes.func,
        }),
        location: PropTypes.shape({
            pathname: PropTypes.string.isRequired,
        }).isRequired,
    };

    constructor() {
        super();

        this.state = {
            loadingModal: false,
            modalOpenedOnPageLoad: false,
            productThirdPartyStreamNamesPush: [],
            urlResetDone: false,
        };
    }

    componentDidUpdate(prevProps, prevState) {
        const prevData = prevProps.DataProductThirdPartyStreamNamesPush.thirdPartyClientStreamNamesPush;
        const currentData = this.props.DataProductThirdPartyStreamNamesPush.thirdPartyClientStreamNamesPush;

        if (prevData !== currentData) {
            this.processThirdPartyStreamNames();
        }

        if (this.shouldHandleRouteModal(prevState)) {
            this.handleRouteModal();
        }
    }

    processThirdPartyStreamNames = () => {
        const {thirdPartyClientStreamNamesPush} = this.props.DataProductThirdPartyStreamNamesPush;

        if (!thirdPartyClientStreamNamesPush) return;

        this.setState({
            productThirdPartyStreamNamesPush: this.sortStreamNames(thirdPartyClientStreamNamesPush),
        });
    };

    shouldHandleRouteModal = (prevState) => {
        return prevState.productThirdPartyStreamNamesPush !== this.state.productThirdPartyStreamNamesPush
            && this.state.productThirdPartyStreamNamesPush
            && !this.state.modalOpenedOnPageLoad;
    };

    sortStreamNames = (streamNames) => {
        return sortByTextValue(streamNames, 'stream_name');
    };

    handleRouteModal = () => {
        const {match} = this.props;
        const {add, edit} = routes.clients.products.thirdParty.streamNamesPush;

        switch (match.path) {
            case add.path:
                this.openModal({});
                break;

            case edit.path:
                this.openEditModal(this.state.productThirdPartyStreamNamesPush);
                break;

            default:
                break;
        }
    };

    openEditModal = (sortedStreamNames) => {
        const {match} = this.props;
        const streamName = sortedStreamNames.find(
            item => convertToInt(item.id) === convertToInt(match.params.thirdPartyClientPushStreamNameId)
        );

        handleEditStreamNameModal(
            streamName,
            'clients.products.thirdParty.streamNamesPush.index',
            convertToInt(match.params.id),
            'push',
            this.openModal
        );
    };

    resetIndexUrl = () => {
        const targetUrl = getLink('clients.products.thirdParty.streamNamesPush.index', {
            id: this.props.match.params.id,
        });

        this.setState({urlResetDone: true}, () => {
            this.props.history.push(targetUrl);
        });
    };

    queryDataForModal = (id) => {
        let modalLink = getLink('clients.products.thirdParty.streamNamesPush.edit', {
            id: this.props.match.params.id,
            thirdPartyClientPushStreamNameId: id,
        });

        this.setState(() => ({
            loadingModal: true,
        }));

        this.props.client.query({
            query: ProductThirdPartyStreamNamePushQuery,
            variables: {
                id: id,
            },
        }).then((result) => {
            this.setState(() => ({
                loadingModal: false,
            }));

            this.openModal(result.data.thirdPartyClientStreamNamePush, modalLink);
        });
    };

    prepareDataForModal = (id) => {
        this.setState(() => ({
            modalOpenedOnPageLoad: true,
        }));

        let modalLink = getLink('clients.products.thirdParty.streamNamesPush.add', {
            id: this.props.match.params.id,
        });

        if (!isNaN(id)) {
            this.queryDataForModal(id);
        } else if (_has(id, 'id')) {
            this.queryDataForModal(id.id);
        } else {
            this.openModal({}, modalLink);
        }
    };

    openModal = (data, modalLink) => {
        if (modalLink && this.props.location.pathname !== modalLink) {
            this.props.history.push(modalLink);
        }

        showModal({
            header: 'Error',
            content: <ProductThirdPartyStreamNamesPushForm
                formData={{
                    cdns: this.props.cdns.map((cdn) => ({
                        key: cdn.id,
                        text: cdn.name,
                        value: cdn.id,
                    })),
                    thirdPartyStreamName: data,
                }}
                resetIndexUrl={this.resetIndexUrl}
            />,
            isVisible: true,
            size: 'small',
            onClose: this.resetIndexUrl,
        });
    };

    render() {
        return (
            <Segment basic loading={this.state.loadingModal}>
                <HeaderRenderer
                    buttons={ProductThirdPartyStreamNamesIndexButtons}
                    buttonsProps={{
                        prepareDataForModal: this.prepareDataForModal,
                        type: PUSH,
                    }}
                    exportExcelParams={exportExcel(
                        this.state.productThirdPartyStreamNamesPush,
                        this.props.match.params.id,
                        PUSH
                    )}
                    loading={this.props.DataProductThirdPartyStreamNamesPush.loading}
                />
                <ProductThirdPartyStreamNamesPushTable
                    editClick={this.prepareDataForModal}
                    loading={this.props.DataProductThirdPartyStreamNamesPush.loading}
                    productThirdPartyStreamNamesPush={this.state.productThirdPartyStreamNamesPush}
                />
            </Segment>
        );
    }
}

const ProductThirdPartyStreamNamesPushQuery = gql(thirdPartyStreamNamesPushGraphQl.thirdPartyStreamNamesPushIndex);
const ProductThirdPartyStreamNamePushQuery = gql(thirdPartyStreamNamesPushGraphQl.thirdPartyStreamNamePush);

const ProductThirdPartyStreamNamesPushWithGraphQL = compose(
    graphql(ProductThirdPartyStreamNamesPushQuery, {
        options: (props) => {
            return {
                fetchPolicy: 'network-only',
                notifyOnNetworkStatusChange: true,
                variables: {
                    thirdPartyClientCdn: props.cdns.map((cdn) => convertToInt(cdn.id)),
                },
            };
        },
        name: 'DataProductThirdPartyStreamNamesPush',
    })
)(ProductThirdPartyStreamNamesPushIndex);

const mapStateToProps = (state) => {
    return {
        cdns: state.app.entities.thirdPartyClientCdns.cdns,
    };
};

export default withRouter(
    connect(mapStateToProps)(withApollo(ProductThirdPartyStreamNamesPushWithGraphQL))
);
